
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBatteryVertical25 as ObiBatteryVertical25Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-battery-vertical-25.js';
 
 
 

 
 export const ObiBatteryVertical25 = createComponent({
   react: React,
   tagName: 'obi-battery-vertical-25',
   elementClass: ObiBatteryVertical25Element,
   events: {
     
   }
  });
 
 